import { useEffect } from "react";
import { connect } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";

import { ROUTES } from "../commons";
import DashboardLayout from "../layouts/dashboard";
import LogoOnlyLayout from "../layouts/LogoOnlyLayout";
import ThemeConfig from "../theme";
import GlobalStyles from "../theme/globalStyles";

import PrivateRoute from "./auth/PrivateRoute";
import Signin from "./auth/Signin";
import Signup from "./auth/Signup";
import Profile from "./elements/authentication/Profile";
import Articles from "./articles/ArticleList";

import DashboardApp from "./DashboardApp";
import Dev from "./dev/Dev";

import NotFound from "./NotFound";
import UserList from "./users/UserList";
import Terms from "./terms/Terms";
import Privacy from "./terms/Privacy";
import PatientList from "./users/PatientList";
import PatientDetail from "./users/PatientDetail";

import DtxaPrivacy from "./dtxa/Privacy";
import DtxbPrivacy from "./dtxb/Privacy";
import MochiPrivacy from "./mochi/Privacy";

const Container = ({ authenticate }) => {
  useEffect(() => {
    authenticate();
  }, [authenticate]);

  return (
    <ThemeConfig>
      <GlobalStyles />

      <Routes>
        <Route
          path={ROUTES.Dashboard}
          element={<PrivateRoute element={<DashboardLayout />} />}
        >
          <Route path="" element={<DashboardApp />} />
        </Route>
        <Route
          path={ROUTES.Profile}
          element={<PrivateRoute element={<DashboardLayout />} />}
        >
          <Route path="" element={<Profile />} />
        </Route>
        <Route path={`/auth`} element={<LogoOnlyLayout />}>
          <Route path={`signin`} element={<Signin />} />
          <Route path={`register`} element={<Signup />} />
        </Route>
        <Route
          path={ROUTES.Root}
          element={<PrivateRoute element={<DashboardLayout />} />}
        >
          <Route
            path={ROUTES.Root}
            element={<Navigate to={ROUTES.Dashboard} />}
          />
          <Route path="articles" element={<Articles />} />
          <Route path="patients" element={<PatientList />} />
          <Route path="patients/:userId" element={<PatientDetail />} />
          <Route path="users" element={<UserList />} />
          <Route path="dev" element={<Dev />} />
        </Route>

        <Route path={ROUTES.Privacy} element={<LogoOnlyLayout />}>
          <Route path={``} element={<Privacy />} />
        </Route>
        <Route path={ROUTES.Terms} element={<LogoOnlyLayout />}>
          <Route path={``} element={<Terms />} />
        </Route>

        <Route path={ROUTES.DtxaPrivacy} element={<LogoOnlyLayout />}>
          <Route path={``} element={<DtxaPrivacy />} />
        </Route>
        <Route path={ROUTES.DtxbPrivacy} element={<LogoOnlyLayout />}>
          <Route path={``} element={<DtxbPrivacy />} />
        </Route>
        <Route path={ROUTES.MochiPrivacy} element={<LogoOnlyLayout />}>
          <Route path={``} element={<MochiPrivacy />} />
        </Route>

        <Route path={"*"} element={<NotFound />} />
      </Routes>
    </ThemeConfig>
  );
};

const mapDispatch = ({ auth: { authenticate } }) => ({ authenticate });

export default connect(null, mapDispatch)(Container);
